import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBuilding, faPlane, faPlus, faUser, faShip, faBullhorn,
} from '@fortawesome/free-solid-svg-icons';
import ServiceComponentIcon from '../ServiceComponentIcon';

function ComponentIcon({
    component, className, subComponent,
})
{
    const icons = {
        Flight: faPlane,
        Hotel: faBuilding,
        Insurance: faPlus,
        Service: faBullhorn,
        Cruise: faShip,
    };

    const icon = icons[component] ?? faUser;

    return component === 'Service' && subComponent
        ? <ServiceComponentIcon service={subComponent} />
        : <FontAwesomeIcon className={className} icon={icon} />;
}

ComponentIcon.propTypes = {
    subComponent: PropTypes.string,
    component: PropTypes.string.isRequired,
};

export default ComponentIcon;
